import { StrictMode, useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { buildDefaultConfig, validateConfig, type AppConfig } from '../shared/config';
import { CustomerPage } from './customer/CustomerPage';
import { AdminPage } from './admin/AdminPage';
import './styles.css';

function App() {
  const [config, setConfig] = useState<AppConfig>(buildDefaultConfig());
  useEffect(() => { fetch('/api/config').then((response) => response.ok ? response.json() : Promise.reject()).then((value) => setConfig(validateConfig(value))).catch(() => undefined); }, []);
  return location.pathname.startsWith('/admin') ? <AdminPage initial={config} /> : <CustomerPage config={config} />;
}

createRoot(document.getElementById('root')!).render(<StrictMode><App /></StrictMode>);
